var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    className: "me-2",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2489_11248)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.84426e-07 1.92155C2.84426e-07 1.41192 0.202448 0.92317 0.562808 0.56281C0.923168 0.20245 1.41192 2.56169e-06 1.92155 2.56169e-06H21.0764C21.3289 -0.000409924 21.5791 0.0489956 21.8125 0.14539C22.0459 0.241785 22.2581 0.383276 22.4368 0.561763C22.6154 0.74025 22.7572 0.952227 22.8538 1.18556C22.9505 1.41889 23.0001 1.66899 23 1.92155V21.0764C23.0003 21.329 22.9507 21.5791 22.8542 21.8126C22.7577 22.046 22.6161 22.2582 22.4376 22.4368C22.259 22.6155 22.0469 22.7572 21.8136 22.8538C21.5802 22.9505 21.33 23.0001 21.0774 23H1.92155C1.66912 23 1.41916 22.9503 1.18596 22.8536C0.95276 22.757 0.740884 22.6154 0.562438 22.4368C0.383992 22.2583 0.242474 22.0463 0.145969 21.8131C0.0494639 21.5798 -0.000137054 21.3298 2.84426e-07 21.0774V1.92155ZM9.10382 8.76927H12.2182V10.3333C12.6678 9.43418 13.8178 8.625 15.5459 8.625C18.859 8.625 19.6441 10.4159 19.6441 13.7017V19.7884H16.2913V14.4503C16.2913 12.5789 15.8418 11.523 14.7001 11.523C13.1163 11.523 12.4576 12.6615 12.4576 14.4503V19.7884H9.10382V8.76927ZM3.35382 19.6451H6.70764V8.625H3.35382V19.6441V19.6451ZM7.1875 5.03073C7.19382 5.31789 7.14273 5.60342 7.0372 5.87056C6.93168 6.1377 6.77387 6.38108 6.57301 6.5864C6.37216 6.79172 6.13232 6.95486 5.86757 7.06624C5.60281 7.17761 5.31848 7.23498 5.03125 7.23498C4.74402 7.23498 4.45969 7.17761 4.19493 7.06624C3.93018 6.95486 3.69034 6.79172 3.48949 6.5864C3.28863 6.38108 3.13082 6.1377 3.0253 5.87056C2.91977 5.60342 2.86868 5.31789 2.875 5.03073C2.88741 4.46708 3.12004 3.93069 3.52306 3.53645C3.92609 3.1422 4.46746 2.92144 5.03125 2.92144C5.59504 2.92144 6.13642 3.1422 6.53944 3.53645C6.94246 3.93069 7.17509 4.46708 7.1875 5.03073Z",
    fill: "url(#paint0_linear_2489_11248)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2489_11248",
    x: 0,
    y: 0,
    width: 23,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_11248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2489_11248",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A88FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C75DE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16);
export default __webpack_public_path__ + "static/media/icon16.bcaa084ae4b79154a0dfe86aea26d06f.svg";
export { ForwardRef as ReactComponent };